// const serverAddress = "http://localhost:8080";
// import Env from 'dotenv'
const serverAddress = window.__ENV__?.REACT_APP_SERVERADDRESS || process.env.REACT_APP_SERVERADDRESS;
export { serverAddress };

